import { makeStyles } from '@material-ui/styles'

const styles = makeStyles(() => ({
  notifTextContainer: {
    width: 350,
    textWrap: 'wrap',
  },
  notifTitle: {
    fontWeight: 'bold',
  },
  notifDescription: {
    color: '#555',
    fontSize: '1.5rem',
  },
  notifCreatedAt: {
    color: '#555',
    fontSize: '1.3rem',
    textAlign: 'right',
  },
}))

export default styles
